import { render, staticRenderFns } from "./addCourseBook.vue?vue&type=template&id=1fb89364&"
import script from "./addCourseBook.vue?vue&type=script&lang=js&"
export * from "./addCourseBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports